<!--工作室查询组件-->
<template>
    <div class="content-container">
        <div class="studio-query-container">
            <div class="studio-topimg-container">
                <img src="../../assets/ms_title.png" alt>
            </div>
            <!-- 查询条件-->
            <div class="form-box">
                <el-form ref="queryForm"
                         :model="queryParams"
                         :inline="true"
                         label-width="40px">
                    <el-row class="mt10 ml10" >
                        <el-col :span="4" class="mb0">
                            <el-form-item label="学段">
                                <el-select clearable @change="changePeriod" v-model="queryParams.periodKey" placeholder="请选择">
                                    <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"
                                               :value="item.dictKey" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4" class="mb0">
                            <el-form-item label="年级">
                                <el-select clearable @change="changeGrade" v-model="queryParams.gradeKey" placeholder="请选择">
                                    <el-option v-for="item in gradeList" :key="item.dictKey" :label="item.dictValue"
                                               :value="item.dictKey" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4" class="mb0">
                            <el-form-item label="学科">
                                <el-select clearable @change="homePageListGroup(null)" v-model="queryParams.subjectKey" placeholder="请选择">
                                    <el-option v-for="item in subjectList" :key="item.dictKey" :label="item.dictValue"
                                               :value="item.dictKey" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" class="mr0 mb0"></el-col>
                        <el-col :span="6" class="mr0 mb0">
                            <el-form-item class="pull-right">
                                <el-input v-model="queryParams.groupName" placeholder="请输入名称" class="input-with-select">
                                    <template #append>
                                        <el-button type="primary" @click="homePageListGroup(null)" style="background-color: #ff7f2e;color: #fff" icon="el-icon-search" />
                                    </template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div class="studio-list-container">
                <div class="group-content" v-loading="loading">
                    <div class="group-item" @click="viewStudioDetail(item)" v-for="item in dataList" :key="item">
                        <div class="group-one">
                            <div class="group-name">
                                {{item.groupName}}
                            </div>
                            <div class="group-subject" >
                                {{ item.periodName === '' || item.periodName == null ? '' : item.periodName }}
                                {{ item.subjectName === '' || item.subjectName == null ? '' : item.subjectName }}
                            </div>
                            <div class="group-cover-stats">
                                <div class="group-cover">
                                    <img class="group-cover-img" :src="item.groupAvatar" alt />
                                </div>
                                <div class="group-stats">
                                    <div class="stats-item">
                                        成员：{{item.memberList.length}}
                                    </div>
                                    <div class="stats-item">
                                        关注：{{item.careNum}}
                                    </div>
                                    <div class="stats-item">
                                        成果：{{item.achieveNum}}
                                    </div>
                                    <div class="stats-item">
                                        文章：{{item.articleNum}}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <data-empty v-if="dataList&&dataList.length===0" title="暂无工作室"/>
            </div>
            <div class="page-container">
                <pageTag :background="true"
                         :pageSizes="[8, 12, 16]"
                         v-show="total > 0"
                         :total="total"
                         v-model:page.sync="queryParams.pageNum"
                         v-model:limit.sync="queryParams.pageSize"
                         @pagination="homePageListGroup" />
            </div>
        </div>
    </div>
</template>

<script>
import dataEmpty from "@/components/dataEmpty.vue";
import pageTag from "@/components/Pagination/page.vue";
import {queryDict} from "@/api/admin/public";
import {pageGroup} from "@/api/admin/system";

export default {
    name:'studioQuery',
    components:{dataEmpty,pageTag},
    props:{
        studioNature:{
            type: String,
            default:"2"
        },
    },
    watch:{},
    mounted() {
        this.getQueryDict();
        this.homePageListGroup();
    },
    updated() {},
    data() {
        return {
            loading:false,
            queryParams: {
                pageNum: 1,
                pageSize: 8,
                groupName:'',
                orgId:'',
                groupNature:'2',
                periodKey: '',
                gradeKey: '',
                subjectKey: '',
            },
            periodList: [],
            gradeList: [],
            subjectList: [],
            total: 0,
            pageCount:0,
            dataList: [],
        }
    },
    methods: {
        getQueryDict() {
            queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                this.periodList = res.data.data;
            })
        },
        changePeriod() {
            this.queryParams.gradeKey = '';
            this.queryParams.subjectKey = '';
            this.gradeList = [];
            this.subjectList = [];
            this.periodList.forEach(j => {
                if (this.queryParams.periodKey === j.dictKey) {
                    this.gradeList = j.childrenList;
                }
            })
            this.homePageListGroup()
        },
        changeGrade() {
            this.queryParams.subjectKey = '';
            this.subjectList = []
            this.periodList.forEach(e => {
                if (this.queryParams.periodKey === e.dictKey) {
                    e.childrenList.forEach(j => {
                        if (this.queryParams.gradeKey === j.dictKey) {
                            this.subjectList = j.childrenList;
                        }
                    })
                }
            })
            this.homePageListGroup()
        },
        homePageListGroup(event){
            this.loading = true;
            if (event) {
                this.queryParams.pageNum = event.page;
                this.queryParams.pageSize = event.limit;
            }
            this.queryParams.groupNature = this.studioNature;
            pageGroup(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.dataList = res.data.data.list;
                    this.total = res.data.data.total;
                    this.pageCount = res.data.data.totalPage;
                }else {
                    this.$message.error("请求出错")
                }
            })
            this.loading=false;
        },
        viewStudioDetail(s){
            let path = 'teachStudioHome';
            if (this.studioNature==='3'){
                path = 'rectorStudioHome';
            }
            //参数传递
            this.$store.commit("params/setJumpParams",
              {activePath:path,activeItem: '2',studioId:s.groupId,studioNature:this.studioNature});
            this.$router.push({path: "/jzedu/studiodetail"});
        },
    }
}
</script>

<style scoped>
.content-container{
    width: 100%;
    height: 100%;
    box-sizing: border-box;
}
/*工作室查询*/
.studio-query-container{
    width: 100%;
    height: auto;
    background-color: #fff;
}
.studio-topimg-container{
    width: 100%;
    height: 160px;
    img{
        width: 100%;
        height: 100%;
    }
}
/*查询条件*/
.form-box{
    width: 98%;
    height: 40px;
    margin: auto;
    border-bottom: 2px solid #ff7f2e;
}
/*工作室内容*/
.studio-list-container{
    width: 100%;
    height: 360px;
    margin: auto;
    overflow-x: hidden;
}
/*名师名校长*/
.group-content{
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    padding-left: 8px;
    align-items: center;
    box-sizing: border-box;
}
.group-item{
    width: 25%!important;
    height: 180px;
    padding: 10px 10px 10px 10px;
    box-sizing: border-box;
    border-radius: 10px;
}
.group-one{
    width: 100%;
    height: 100%;
    box-shadow: var(--el-box-shadow-light);
    border-radius: 10px;
    padding: 10px 0 10px 10px;
    box-sizing: border-box;
    cursor: pointer;
}
.group-name{
    width: 95%;
    height: 30px;
    line-height: 30px;
    font-size: 15px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: bold;
    color: #333333;
}
.group-subject{
    width: 95%;
    height: 24px;
    line-height: 24px;
    background-color: #caa87b;
    color: #fff;
    font-size: 14px;
    text-indent: 5px;
}
.group-cover-stats{
    display: flex;
    width: 95%;
    height: auto;
}
.group-cover{
    padding-left: 10px;
    margin-top: 10px;
    width: 80px;
    height: 80px;

}
.group-cover-img{
    width: 80px;
    height: 80px;
    border-radius: 40px;
}
.group-stats{
    padding-left: 30px;
    box-sizing: border-box;
    margin-top: 10px;
    width: calc(100% - 80px);
}
.stats-item{
    height: 20px;
    line-height: 20px;
    font-size: 14px;
}
/*选择框高度*/
.page-container{
    display: grid;
    place-items: center;
    width: 98%;
    height: 40px;
    margin-bottom: 10px;
    padding-bottom: 20px;
}
</style>